import { Record } from "immutable";

const Account = new Record({
  key: null,
  sessions: null,
});

export default Account;
